import React from 'react';

const KeyContext = React.createContext( undefined );

export default KeyContext;
